module.exports = __webpack_public_path__ + "img/process_6.bab3898c.svg";